/**
 * Run callback when DOM is ready.
 *
 * @param fn The callback function to execute.
 */
function ready(fn: () => unknown) {
	if (document.readyState !== "loading") fn();
	else document.addEventListener("DOMContentLoaded", fn);
}

neutralizeStaggsScrollReset();

ready(() => {
	initCountryReorder();
});

/**
 * Country Dropdown Reorder: Sorts country selection on the secondary owner
 * form.
 */
function initCountryReorder() {
	const path = window.location.pathname.replace(/\/$/, "");
	if (path !== "/owners/secondary-owner-registration") {
		return;
	}

	if (document.body.dataset.roadtrekCountrySort === "1") return;

	const select = document.querySelector('select[name="form_fields[country]"]');
	if (!select) return;

	let usOption: HTMLOptionElement | null = null;
	let caOption: HTMLOptionElement | null = null;
	const otherOptions: HTMLOptionElement[] = [];

	for (const opt of Array.from(select.querySelectorAll("option"))) {
		if (opt.value === "US") {
			usOption = opt;
		} else if (opt.value === "CA") {
			caOption = opt;
		} else {
			otherOptions.push(opt);
		}
	}

	if (!usOption && !caOption) return;

	select.replaceChildren();

	if (usOption) select.appendChild(usOption);
	if (caOption) select.appendChild(caOption);

	const sep = document.createElement("option");
	sep.value = "";
	sep.disabled = true;
	sep.textContent = "───────────";
	select.appendChild(sep);

	otherOptions.forEach((opt) => select.appendChild(opt));
	document.body.dataset.roadtrekCountrySort = "1";
}

/**
 * Staggs / Staggs Pro's public JS (the "Build Your Own" configurator, loaded on
 * individual model pages) unconditionally does:
 *
 * Window.onbeforeunload = function () { window.scrollTo(0, 0); };
 *
 * That fires on every navigation away from the page (link clicks, back button,
 * etc.), and because the site sets `scroll-behavior: smooth` globally, the
 * reset animates over ~800ms — visible as the page scrolling to the top right
 * before it navigates away.
 *
 * Trap assignments to `window.onbeforeunload` so that handler can never be
 * registered, regardless of script load order. No other frontend script relies
 * on `window.onbeforeunload` (WooCommerce and Elementor only use it in wp-admin
 * contexts), so this is safe to no-op site-wide.
 */
function neutralizeStaggsScrollReset() {
	Object.defineProperty(window, "onbeforeunload", {
		configurable: true,
		get: () => null,
		set: () => {
			/* empty */
		},
	});
}
